/**
 * UUIDv7: time-ordered unique ids, created on the device without asking the server.
 * Dishes and menus created later sort later; ties in time break by id.
 */
let lastMillis = 0;
let counter = 0;

export function uuidv7(now: number = Date.now()): string {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  // A 12-bit counter in rand_a keeps ids from one device in creation order within a millisecond.
  if (now <= lastMillis) {
    counter = (counter + 1) & 0xfff;
    now = lastMillis;
  } else {
    counter = (bytes[6]! & 0x07) << 8 | bytes[7]!;
    lastMillis = now;
  }
  bytes[0] = Math.floor(now / 2 ** 40) & 0xff;
  bytes[1] = Math.floor(now / 2 ** 32) & 0xff;
  bytes[2] = (now >>> 24) & 0xff;
  bytes[3] = (now >>> 16) & 0xff;
  bytes[4] = (now >>> 8) & 0xff;
  bytes[5] = now & 0xff;
  bytes[6] = 0x70 | (counter >> 8);
  bytes[7] = counter & 0xff;
  bytes[8] = 0x80 | (bytes[8]! & 0x3f);
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

export function isId(value: unknown): value is string {
  return typeof value === "string" && UUID.test(value);
}
